import React, { useEffect } from "react";
import { PageLoading } from "@ant-design/pro-layout";
import { connect } from "dva";
import { router } from "umi";
import { getLocalStorage } from "@/utils/storage";
import MaintenanceBanner from "@/components/MaintenanceBanner/MaintenanceBanner";
import SecurityLayout from "./SecurityLayout";
import { publicRoutes } from "./constants";

const MaintenanceModeLayout = ({ children, configMaintenanceMode, dispatch, isLoading, devModeBypass, ...rest }) => {
  useEffect(() => {
    const authData = getLocalStorage("dataAuth");
    const { pathname } = window.location;
    if (authData && authData.access_token && authData.refresh_token) {
      if (publicRoutes.includes(pathname)) {
        // If the user is looking at a public route (eg. /user/login) and is currently logged in
        // then redirect to the home page
        router.push("/");
        return;
      }
    }

    dispatch({
      type: "configs/getConfigData",
    });
  }, []);

  if (isLoading) {
    return <PageLoading />;
  }

  return configMaintenanceMode && !devModeBypass ? (
    <MaintenanceBanner />
  ) : (
    <SecurityLayout {...rest}>{children}</SecurityLayout>
  );
};

export default connect(({ configs, loading }) => ({
  configMaintenanceMode: configs.configMaintenanceMode,
  configFetched: configs.configFetched,
  devModeBypass: configs.devModeBypass,
  isLoading: loading.effects["configs/getConfigData"],
}))(MaintenanceModeLayout);
